import { Card, CardBody } from "reactstrap";
import axiosInstance from "../../helpers/axios";
import { useState, useEffect, useCallback } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import RoomIcon from "@mui/icons-material/Room";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import * as moment from "moment";
import PaginationTable from "../status/PaginationTable";
import statusImage from "../../assets/images/status.png";
import rightArrow from "../../assets/images/chevron-right.png";
import "./Logins.css";
import { classifySource } from "../shared/SourceBadge/sourceIcons";
import { Details, tooltipProps as sourceTooltipProps } from "../shared/SourceBadge/SourceBadge";

const CHEVRON_ICON_URL =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23667085' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E";

const REMARK_OPTIONS = [
  // Call connectivity
  "Not answering calls",
  "Not reachable",
  "Busy",
  "Call disconnected / dropped",
  "Switched off",
  "Out of service",
  "Invalid number / call not connecting",
  "No incoming calls on this number",
  "Wrong number (different person)",
  // Eligibility
  "Age not eligible",
  "Wrong state / not serviceable location",
  "FOIR exceeding",
  "Salary paid by hand",
  "Income insufficient",
  "Not employed / student",
  "Self-employed, not eligible",
  "Employer not in approved list",
  "Existing loan default / poor credit history",
  // Disposition
  "Not interested",
  "Loan not required",
  "Already availed loan elsewhere",
  "Will apply later",
  "Requested callback",
  "Language barrier",
  "Duplicate lead",
  // Internal
  "Internal / test account",
];

const GoogleIcon = () => (
  <svg width="14" height="14" viewBox="0 -13 256 256" aria-hidden="true">
    <path
      fill="#FBBC04"
      d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
    />
    <path
      fill="#4285F4"
      d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
    />
    <ellipse fill="#34A853" cx="42.6637241" cy="187.924414" rx="42.6637241" ry="41.6044138" />
  </svg>
);

const MetaIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="#0082FB"
      d="M16.0235,4.50341 C17.8529,4.3766 19.267,5.44519 20.2076,6.67737 C21.156,7.91976 21.8094,9.54336 22.1673,11.1394 C22.5251,12.7347 22.6208,14.4504 22.3239,15.9123 C22.0388,17.3161 21.2785,18.9223 19.5568,19.437 C17.9375,19.9211 16.5179,19.2167 15.5052,18.3648 C14.4894,17.5103 13.6292,16.3122 12.953,15.1885 C12.6252,14.6438 12.3272,14.0938 12.0637,13.573 C11.8001,14.0938 11.5021,14.6438 11.1743,15.1885 C10.4981,16.3122 9.63792,17.5103 8.62209,18.3648 C7.60941,19.2167 6.18982,19.9211 4.57048,19.437 C2.84884,18.9223 2.08848,17.3161 1.80341,15.9123 C1.50655,14.4504 1.60217,12.7347 1.95995,11.1394 C2.31789,9.54336 2.97134,7.91976 3.91972,6.67737 C4.86029,5.44519 6.27437,4.3766 8.10383,4.50341 C9.81996636,4.62237364 11.0674829,5.78648603 11.8446591,6.77187041 L12.0637,7.0609 L12.0637,7.0609 L12.2827156,6.77187041 C13.059814,5.78648603 14.3073182,4.62237364 16.0235,4.50341 Z M7.89637,7.49623 C7.47584,7.46708 6.92691,7.6821 6.30436,8.49766 C5.68961,9.30301 5.17981,10.4913 4.88724,11.7959 C4.59453,13.1011 4.5524,14.3747 4.74341,15.3153 C4.90819312,16.126825 5.17222414,16.4173547 5.33536471,16.5186918 L5.40276778,16.5532373 L5.42973,16.5627 C5.6624,16.6322 6.04382,16.6134 6.69089,16.0691 C7.33482,15.5274 7.99318,14.6564 8.60392,13.6416 C8.87629333,13.1890333 9.12860444,12.7252222 9.35564593,12.2790926 L9.61563301,11.7540754 L9.8493616,11.25714 L10.0548321,10.7993939 L10.2300447,10.3919447 L10.373,10.0459 C10.2165,9.73315 9.99218,9.32834 9.71032,8.92724 C9.06612,8.01052 8.42073,7.53258 7.89637,7.49623 Z M16.2309,7.49623 C15.7066,7.53258 15.0612,8.01052 14.417,8.92724 C14.1351,9.32834 13.9108,9.73315 13.7543,10.0459 L13.9809584,10.588688 L14.1715556,11.0226741 C14.2058156,11.0990422 14.2412947,11.1772747 14.2779512,11.25714 L14.511686,11.7540754 L14.7716778,12.2790926 C14.9987222,12.7252222 15.2510333,13.1890333 15.5234,13.6416 C16.1341,14.6564 16.7925,15.5274 17.4364,16.0691 C18.0372786,16.5745214 18.4090587,16.6268332 18.6454171,16.576082 L18.6976,16.5627 C18.8279,16.5237 19.1811,16.3141 19.3839,15.3153 C19.5749,14.3747 19.5328,13.1011 19.2401,11.7959 C18.9475,10.4913 18.4377,9.30301 17.8229,8.49766 C17.2004,7.6821 16.6515,7.46708 16.2309,7.49623 Z"
    />
  </svg>
);

const OrganicIcon = () => (
  <svg width="14" height="14" viewBox="0 0 512 512" aria-hidden="true">
    <path
      fill="#5d5b5b"
      d="M476.188,24.146c-6.748-3.504-60.728,38.022-185.304,67.086C230.347,105.355,62.5,153.527,65.286,392.815 L0,431.218l20.338,35.598c63.073-40.692,236.014-120.042,409.766-323.621c0,0-26.875,134.419-334.096,311.056 c103.685,53.758,249.604,53.758,360.979-76.806C568.346,246.888,476.188,24.146,476.188,24.146z"
    />
  </svg>
);

const badgeTooltipProps = {
  arrow: true,
  componentsProps: {
    tooltip: {
      sx: {
        backgroundColor: "#101828",
        color: "#fff",
        fontFamily: "Inter-Medium",
        fontSize: "12px",
        padding: "6px 14px",
        borderRadius: "999px",
      },
    },
    arrow: {
      sx: { color: "#101828" },
    },
  },
};

const getCampaignLabel = (campaignName, mediaSource) => {
  if (campaignName) return campaignName;
  if ((mediaSource || "").toLowerCase().includes("organic")) return "Organic User";
  return null;
};

const getSourceBadge = (mediaSource, campaignName) => {
  const source =
    classifySource(mediaSource, { campaignName }) ||
    ((campaignName || "").toLowerCase().includes("organic") ? classifySource("organic") : null);
  if (!source) return null;

  // Campaign and adset already have their own columns here, so the card only names the source
  const title =
    source.type === "organic" ? (
      <span className="source-badge-tip__title source-badge-tip__title--only">Organic</span>
    ) : (
      <Details
        title={source.label}
        rows={[
          ...(source.partner ? [["Partner", source.partner]] : []),
          ...(source.agency ? [["Agency", source.agency], ["Affiliate", mediaSource]] : [["Media source", mediaSource]]),
        ]}
      />
    );

  return (
    <Tooltip title={title} {...sourceTooltipProps}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "24px",
          height: "24px",
          flexShrink: 0,
          borderRadius: "8px",
          backgroundColor: "#F2F4F7",
          cursor: "default",
        }}
      >
        <source.Icon />
      </span>
    </Tooltip>
  );
};

const formatLocation = (raw) => {
  if (!raw) {
    return { primary: "-", full: null, mapsUrl: null };
  }
  try {
    const loc = JSON.parse(raw);
    const primaryParts = [loc.district || loc.city, loc.region].filter(Boolean);
    const primary = primaryParts.length
      ? primaryParts.join(", ")
      : loc.formattedAddress || raw;
    const full =
      loc.formattedAddress ||
      [loc.street, loc.district, loc.city, loc.region, loc.postalCode]
        .filter(Boolean)
        .join(", ") ||
      raw;
    const mapsUrl =
      loc.latitude != null && loc.longitude != null
        ? `https://www.google.com/maps?q=${loc.latitude},${loc.longitude}`
        : null;
    return { primary, full, mapsUrl };
  } catch (e) {
    return { primary: raw, full: raw, mapsUrl: null };
  }
};

const Logins = () => {
  const [filterDateFrom, setFilterDateFrom] = useState(() =>
    moment().subtract(1, "day").startOf("day"),
  );
  const [filterDateTo, setFilterDateTo] = useState(() => moment().endOf("day"));

  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(50);
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [locationAnchor, setLocationAnchor] = useState(null);
  const [activeLocation, setActiveLocation] = useState(null);

  const openLocationPopover = (event, rowKey, location) => {
    setLocationAnchor(event.currentTarget);
    setActiveLocation({ rowKey, full: location.full, mapsUrl: location.mapsUrl });
  };

  const closeLocationPopover = () => {
    setLocationAnchor(null);
    setActiveLocation(null);
  };

  const [remarks, setRemarks] = useState({});
  const [savedRemarkRows, setSavedRemarkRows] = useState({});

  const saveRemark = (rowKey, userId, remarkText) => {
    if (!userId || !remarkText) return;
    setSavedRemarkRows((prev) => ({ ...prev, [rowKey]: false }));
    axiosInstance
      .post("/users/basic-info/pending-application-leads/remark", { userId, remark: remarkText })
      .then(() => {
        setSavedRemarkRows((prev) => ({ ...prev, [rowKey]: true }));
        setRemarks((prev) => ({
          ...prev,
          [rowKey]: { ...prev[rowKey], savedOthersText: remarkText },
        }));
      })
      .catch((error) => {
        alert(error?.response?.data?.message || "Failed to save remark");
      });
  };

  const handleRemarkSelect = (rowKey, value, userId) => {
    setRemarks((prev) => ({
      ...prev,
      [rowKey]: { selected: value, customText: prev[rowKey]?.customText || "" },
    }));
    if (value && value !== "Others") {
      saveRemark(rowKey, userId, value);
    } else {
      setSavedRemarkRows((prev) => ({ ...prev, [rowKey]: false }));
    }
  };

  const handleRemarkTextChange = (rowKey, text) => {
    setRemarks((prev) => ({
      ...prev,
      [rowKey]: { ...prev[rowKey], customText: text },
    }));
    setSavedRemarkRows((prev) => ({ ...prev, [rowKey]: false }));
  };

  const handleRemarkTextBlur = (rowKey, userId) => {
    const text = remarks[rowKey]?.customText?.trim();
    if (text) saveRemark(rowKey, userId, text);
  };

  const fetchLeads = useCallback(() => {
    setIsLoading(true);
    axiosInstance
      .get("/users/basic-info/pending-application-leads", {
        params: {
          fromDate: filterDateFrom.toISOString(),
          toDate: filterDateTo.toISOString(),
          page: currentPage,
          limit: rowsPerPage,
        },
      })
      .then((res) => {
        const rows = res?.data?.data?.rows || [];
        setTableData(rows);
        setTotalRows(res?.data?.data?.total || 0);
        setRemarks((prev) => {
          const next = { ...prev };
          rows.forEach((item, index) => {
            const rowKey = `${item.mobile}-${index}`;
            if (!next[rowKey] && item.remark) {
              next[rowKey] = REMARK_OPTIONS.includes(item.remark)
                ? { selected: item.remark, customText: "" }
                : { selected: "Others", customText: item.remark, savedOthersText: item.remark };
            }
          });
          return next;
        });
        setSavedRemarkRows((prev) => {
          const next = { ...prev };
          rows.forEach((item, index) => {
            const rowKey = `${item.mobile}-${index}`;
            if (next[rowKey] === undefined && item.remark) {
              next[rowKey] = true;
            }
          });
          return next;
        });
      })
      .catch((error) => {
        alert(error?.response?.data?.message || "Failed to load logins");
      })
      .finally(() => setIsLoading(false));
  }, [filterDateFrom, filterDateTo, currentPage, rowsPerPage]);

  useEffect(() => {
    fetchLeads();
  }, [fetchLeads]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const validToDate = (current) => current.isAfter(filterDateFrom);

  return (
    <Card className="logins-page" style={{ width: "100%", height: "100%" }}>
      <CardBody>
        <div>
          <p style={{ display: "flex", alignItems: "center" }}>
            <img src={statusImage} alt="" />
            <span
              style={{
                fontFamily: "Inter-Medium",
                marginLeft: "10px",
                fontSize: "14px",
              }}
            >
              status
            </span>
            <span style={{ marginLeft: "20px", marginBottom: "3px" }}>
              <img
                style={{ height: "18px", width: "14px" }}
                src={rightArrow}
                alt=""
              />
            </span>
            <span
              style={{
                fontFamily: "Inter-Medium",
                marginLeft: "10px",
                fontSize: "14px",
                color: "#D32028",
              }}
            >
              Logins
            </span>
          </p>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            marginBottom: "20px",
          }}
        >
          <p
            style={{ fontFamily: "Inter-Medium", fontSize: "16px", margin: 0 }}
          >
            Logins without an application yet
          </p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: "10px" }}>
              <Datetime
                closeOnSelect
                dateFormat="DD MMM YYYY"
                timeFormat={false}
                value={filterDateFrom}
                onChange={(value) => {
                  if (value && value.format) {
                    setCurrentPage(1);
                    setFilterDateFrom(value.clone().startOf("day"));
                  }
                }}
                inputProps={{
                  placeholder: "From Date",
                  style: {
                    fontFamily: "Inter",
                    fontSize: "14px",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    border: "1px solid #D0D5DD",
                    outline: "none",
                  },
                }}
              />
            </div>
            <div style={{ marginRight: "10px" }}>
              <Datetime
                closeOnSelect
                dateFormat="DD MMM YYYY"
                timeFormat={false}
                isValidDate={validToDate}
                value={filterDateTo}
                onChange={(value) => {
                  if (value && value.format) {
                    setCurrentPage(1);
                    setFilterDateTo(value.clone().endOf("day"));
                  }
                }}
                inputProps={{
                  placeholder: "To Date",
                  style: {
                    fontFamily: "Inter",
                    fontSize: "14px",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    border: "1px solid #D0D5DD",
                    outline: "none",
                  },
                }}
              />
            </div>
            <button
              onClick={fetchLeads}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "34px",
                width: "42px",
                backgroundColor: "#D22129",
                border: "none",
                borderRadius: "5px",
                color: "white",
                cursor: "pointer",
              }}
              title="Refresh"
            >
              <RefreshIcon />
            </button>
          </div>
        </div>

        {isLoading ? (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <div className="tables" style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", minWidth: "900px", tableLayout: "fixed" }}>
                <colgroup>
                  <col style={{ width: "115px" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "22%" }} />
                  <col style={{ width: "16%" }} />
                  <col style={{ width: "190px" }} />
                  <col style={{ width: "260px" }} />
                </colgroup>
                <thead className="table-heading">
                  <tr>
                    {[
                      "Mobile",
                      "Location",
                      "Campaign",
                      "Adset",
                      "Signed Up",
                      "Remarks",
                    ].map((label) => (
                      <th
                        key={label}
                        style={{
                          fontSize: "11px",
                          fontFamily: "Inter-Medium",
                          padding: label === "Remarks" ? "14px 10px 14px 24px" : "14px 10px",
                          textAlign: "left",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                          color: "#98A2B3",
                        }}
                      >
                        {label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((item, index) => {
                    const location = formatLocation(item.location);
                    const rowKey = `${item.mobile}-${index}`;
                    const isOpen = activeLocation?.rowKey === rowKey;
                    const isRemarkSaved = Boolean(savedRemarkRows[rowKey]);
                    return (
                      <tr className="table-row" key={rowKey}>
                        <td
                          style={{
                            fontSize: "14px",
                            fontFamily: "Inter",
                            padding: "6px 10px",
                            color: "#667085",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.mobile}
                        </td>
                        <td
                          style={{
                            fontSize: "14px",
                            fontFamily: "Inter",
                            padding: "6px 10px",
                            color: "#667085",
                          }}
                        >
                          <span
                            title={location.primary}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              color: "#344054",
                              fontFamily: "Inter",
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {location.primary}
                            </span>
                            {location.full && (
                              <span
                                onClick={(e) => openLocationPopover(e, rowKey, location)}
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  flexShrink: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "50%",
                                  border: "1px solid #D0D5DD",
                                  cursor: "pointer",
                                }}
                              >
                                <ExpandMoreIcon
                                  style={{
                                    fontSize: "14px",
                                    color: "#667085",
                                    transform: isOpen ? "rotate(180deg)" : "rotate(-90deg)",
                                    transition: "transform 0.15s ease",
                                  }}
                                />
                              </span>
                            )}
                          </span>
                        </td>
                        <td style={{ padding: "6px 10px", overflow: "hidden" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              overflow: "hidden",
                            }}
                          >
                            <span
                              title={item.campaign_name}
                              style={{
                                fontFamily: "Inter-Medium",
                                fontSize: "14px",
                                color: getCampaignLabel(item.campaign_name, item.media_source) ? "#101828" : "#667085",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {getCampaignLabel(item.campaign_name, item.media_source) || "-"}
                            </span>
                            {getSourceBadge(item.media_source, item.campaign_name)}
                          </div>
                        </td>
                        <td
                          title={item.adset_name}
                          style={{
                            padding: "6px 10px",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            color: "#667085",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.adset_name || "-"}
                        </td>
                        <td
                          style={{
                            padding: "6px 10px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.created_at ? (
                            <span
                              style={{
                                fontFamily: "Inter",
                                fontSize: "14px",
                                color: "#475467",
                              }}
                            >
                              {moment(item.created_at).format("DD MMM YYYY")}
                              <span
                                style={{ color: "#D0D5DD", margin: "0 1px" }}
                              >
                                &middot;
                              </span>
                              <span style={{ color: "#98A2B3", }}>
                                {moment(item.created_at).format("hh:mm A")}
                              </span>
                            </span>
                          ) : (
                            <span
                              style={{
                                fontFamily: "Inter",
                                fontSize: "14px",
                                color: "#667085",
                              }}
                            >
                              -
                            </span>
                          )}
                        </td>
                        <td style={{ padding: "1px 10px 1px 24px" }}>
                          <select
                            value={remarks[rowKey]?.selected || ""}
                            disabled={isRemarkSaved}
                            title={
                              remarks[rowKey]?.selected === "Others"
                                ? remarks[rowKey]?.savedOthersText
                                : remarks[rowKey]?.selected
                            }
                            onChange={(e) =>
                              handleRemarkSelect(rowKey, e.target.value, item.user_id)
                            }
                            style={{
                              width: "100%",
                              height: "32px",
                              lineHeight: "20px",
                              boxSizing: "border-box",
                              appearance: "none",
                              WebkitAppearance: "none",
                              MozAppearance: "none",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              padding: "6px 14px",
                              fontSize: "14px",
                              fontFamily: isRemarkSaved ? "Inter-Medium" : "Inter",
                              color: isRemarkSaved ? "#166534" : "#344054",
                              backgroundColor: isRemarkSaved ? "#DCFCE7" : "white",
                              border: isRemarkSaved ? "none" : "1px solid #D0D5DD",
                              borderRadius: "20px",
                              backgroundImage: isRemarkSaved ? "none" : `url("${CHEVRON_ICON_URL}")`,
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "right 12px center",
                              backgroundSize: "12px",
                              cursor: isRemarkSaved ? "not-allowed" : "pointer",
                            }}
                          >
                            <option value="">Select remark</option>
                            {REMARK_OPTIONS.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                            <option value="Others">
                              {remarks[rowKey]?.selected === "Others" && remarks[rowKey]?.savedOthersText
                                ? remarks[rowKey].savedOthersText
                                : "Others"}
                            </option>
                          </select>
                          {remarks[rowKey]?.selected === "Others" && !isRemarkSaved && (
                            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "6px" }}>
                              <input
                                type="text"
                                placeholder="Enter remark"
                                maxLength={100}
                                value={remarks[rowKey]?.customText || ""}
                                onChange={(e) =>
                                  handleRemarkTextChange(rowKey, e.target.value)
                                }
                                onBlur={() => handleRemarkTextBlur(rowKey, item.user_id)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleRemarkTextBlur(rowKey, item.user_id);
                                  }
                                }}
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                  padding: "2px 4px",
                                  fontSize: "13px",
                                  fontFamily: "Inter",
                                  color: "#344054",
                                  border: "1px solid #D0D5DD",
                                  borderRadius: "6px",
                                }}
                              />
                              <button
                                type="button"
                                onClick={() => handleRemarkTextBlur(rowKey, item.user_id)}
                                style={{
                                  flexShrink: 0,
                                  padding: "2px 6px",
                                  fontSize: "12px",
                                  fontFamily: "Inter-Medium",
                                  color: "white",
                                  backgroundColor: "#D22129",
                                  border: "none",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                }}
                              >
                                Save
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {totalRows ? (
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontFamily: "Inter-Medium",
                  fontSize: "14px",
                  margin: "10px",
                }}
              >
                Showing {(currentPage - 1) * rowsPerPage + 1}-
                {(currentPage - 1) * rowsPerPage + tableData.length} of{" "}
                {totalRows} records
              </div>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  margin: "10px",
                }}
              >
                No Records
              </div>
            )}

            <PaginationTable
              startPage={currentPage}
              rowsPerPage={rowsPerPage}
              totalRows={totalRows}
              paginate={paginate}
              filterDateFrom={filterDateFrom}
              filterDateTo={filterDateTo}
            />
          </>
        )}

        <Popover
          open={Boolean(locationAnchor)}
          anchorEl={locationAnchor}
          onClose={closeLocationPopover}
          anchorOrigin={{ vertical: "center", horizontal: "right" }}
          transformOrigin={{ vertical: "center", horizontal: "left" }}
          PaperProps={{
            style: {
              borderRadius: "12px",
              padding: "16px",
              maxWidth: "300px",
              marginLeft: "10px",
              boxShadow: "0px 12px 24px -4px rgba(16,24,40,0.12)",
            },
          }}
        >
          {activeLocation && (
            <>
              <div
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "11px",
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: "#98A2B3",
                  marginBottom: "6px",
                }}
              >
                LOCATION
              </div>
              <p
                style={{
                  fontSize: "13px",
                  fontFamily: "Inter",
                  color: "#101828",
                  margin: "0 0 12px 0",
                  lineHeight: "1.5",
                }}
              >
                {activeLocation.full}
              </p>
              {activeLocation.mapsUrl && (
                <a
                  href={activeLocation.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#00a2ff",
                    fontFamily: "Inter-Medium",
                    fontSize: "12px",
                    textDecoration: "none",
                  }}
                >
                  <RoomIcon fontSize="inherit" style={{ marginRight: "4px" }} />
                  View on map
                </a>
              )}
            </>
          )}
        </Popover>
      </CardBody>
    </Card>
  );
};

export default Logins;
